/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { DriverFamiliarityScoreDtoModel, DriverFamiliarityScoreDtoModelType } from "./DriverFamiliarityScoreDtoModel"
import { DriverFamiliarityScoreDtoModelSelector } from "./DriverFamiliarityScoreDtoModel.base"
import { RootStoreType } from "./index"


/**
 * DriverAssignInfoDtoBase
 * auto generated base class for the model DriverAssignInfoDtoModel.
 */
export const DriverAssignInfoDtoModelBase = ModelBase
  .named('DriverAssignInfoDto')
  .props({
    __typename: types.optional(types.literal("DriverAssignInfoDto"), "DriverAssignInfoDto"),
    id: types.identifier,
    uuid: types.union(types.undefined, types.string),
    name: types.union(types.undefined, types.string),
    deleted: types.union(types.undefined, types.null, types.boolean),
    speed: types.union(types.undefined, types.null, types.number),
    breakStartTime: types.union(types.undefined, types.null, types.string),
    breakEndTime: types.union(types.undefined, types.null, types.string),
    familiarityScore: types.union(types.undefined, types.null, types.late((): any => DriverFamiliarityScoreDtoModel)),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class DriverAssignInfoDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get uuid() { return this.__attr(`uuid`) }
  get name() { return this.__attr(`name`) }
  get deleted() { return this.__attr(`deleted`) }
  get speed() { return this.__attr(`speed`) }
  get breakStartTime() { return this.__attr(`breakStartTime`) }
  get breakEndTime() { return this.__attr(`breakEndTime`) }
  familiarityScore(builder: string | DriverFamiliarityScoreDtoModelSelector | ((selector: DriverFamiliarityScoreDtoModelSelector) => DriverFamiliarityScoreDtoModelSelector) | undefined) { return this.__child(`familiarityScore`, DriverFamiliarityScoreDtoModelSelector, builder) }
}
export function selectFromDriverAssignInfoDto() {
  return new DriverAssignInfoDtoModelSelector()
}

export const driverAssignInfoDtoModelPrimitives = selectFromDriverAssignInfoDto().uuid.name.deleted.speed.breakStartTime.breakEndTime
